/* SEMEX listicle pages — micro-interactions.
   Loaded only on page.*listicle* templates (see layout/theme.liquid).
   Everything here must degrade to nothing: no JS = fully readable page. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Micro animations: gentle fade-up as sections enter the viewport ── */
  if (!reduceMotion && 'IntersectionObserver' in window) {
    var targets = document.querySelectorAll(
      '.smx-ll-reason__text, .smx-ll-reason__media, .smx-ll-stats .smx-ll-container, .smx-ll-offer__card, .smx-ll-cta-band .smx-ll-container'
    );
    if (targets.length) {
      document.documentElement.classList.add('smx-anim-on');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add('smx-in');
            io.unobserve(en.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      targets.forEach(function (el) {
        el.classList.add('smx-anim');
        io.observe(el);
      });
    }
  }

})();
